import { render, staticRenderFns } from "./InstantRefund.vue?vue&type=template&id=52a875ec&scoped=true&lang=pug&"
import script from "./InstantRefund.vue?vue&type=script&lang=js&"
export * from "./InstantRefund.vue?vue&type=script&lang=js&"
import style0 from "./InstantRefund.vue?vue&type=style&index=0&id=52a875ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a875ec",
  null
  
)

export default component.exports